import React from 'react';
import imgSplit from '../../../assets/images/finale-plein-img1.png';
import imgShake from '../../../assets/images/finale-plein-img2.png';
import {BetType} from "../../../enums/tableNumbers";

export const PlainSplitHolder = ({handleDoChip}) => {
  return (
    <div className="mob-finale-plein-splite-holder">
      <div className="mob-finale-plein-splite-item">
        <div className="mob-finale-plein-splite-block type1" data={BetType.Black_Pairs} onClick={handleDoChip}>
          <img src={imgSplit} alt="" data={BetType.Black_Pairs}/>
        </div>
        <div className="mob-finale-plein-splite-block type2" data={BetType.Red_Pairs} onClick={handleDoChip}>
          <img src={imgSplit} alt="" data={BetType.Red_Pairs}/>
        </div>
      </div>
      <div className="mob-finale-plein-splite-item">
        <div className="mob-finale-plein-splite-block type1" data={BetType.Black_Snake} onClick={handleDoChip}>
          <img src={imgShake} alt="" data={BetType.Black_Snake}/>
        </div>
        <div className="mob-finale-plein-splite-block type2" data={BetType.Red_Snake} onClick={handleDoChip}>
          <img src={imgShake} alt="" data={BetType.Red_Snake}/>
        </div>
      </div>
    </div>
  );
};